var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClipboardCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3027_8330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.92859 4.96875H6.42859C5.32402 4.96875 4.42859 5.86418 4.42859 6.96875V20.9688C4.42859 22.0733 5.32402 22.9688 6.42859 22.9688H12.4286",
    stroke: "#2E4D6B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9286 4.96875H18.4286C19.5332 4.96875 20.4286 5.86418 20.4286 6.96875V15.9688",
    stroke: "#2E4D6B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.42859 7.36875V5.46875C8.42859 5.19261 8.65245 4.96875 8.92859 4.96875C9.20473 4.96875 9.43281 4.74479 9.48011 4.47273C9.62827 3.62046 10.2026 1.96875 12.4286 1.96875C14.6546 1.96875 15.2289 3.62046 15.3771 4.47273C15.4244 4.74479 15.6524 4.96875 15.9286 4.96875C16.2047 4.96875 16.4286 5.19261 16.4286 5.46875V7.36875C16.4286 7.70012 16.16 7.96875 15.8286 7.96875H9.02859C8.69722 7.96875 8.42859 7.70012 8.42859 7.36875Z",
    stroke: "#2E4D6B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9286 21.4688L17.9286 23.4688L22.9286 18.4687",
    stroke: "#2E4D6B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3027_8330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.428589 0.96875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardCheck);
export default __webpack_public_path__ + "static/media/clipboard-check.a30fdcd43211644c58f9589c6fa65e03.svg";
export { ForwardRef as ReactComponent };